module.exports = __webpack_public_path__ + "img/benefit-07-trace-2.fa632ee3.png";